<template>
  <div class="ling-star-rating" :class="{empty}" v-b-tooltip.hover :title="tooltip">
    <i
      class="lgf fs-180"
      :class="index > value ? 'lg-star-outline' : 'lg-star-solid'"
      v-for="index in max"
      :key="index"
    >
    </i>
  </div>
</template>
<style lang="scss">
  .ling-star-rating {
    transition: color .3s ease-in-out, opacity .3s ease-in-out;

    &.empty {
      opacity: 0.3;
    }

    &:not(.empty):hover {
      color: var(--lingusta-green);
    }
  }
</style>
<script>
  export default {
    props: {
      value: {
        type: Number,
        required: true,
        default: -1
      },
      max: {
        type: Number,
        default: 4
      }
    },
    computed: {
      empty() {
        return this.value === -1
      },
      tooltip() {
        if(this.empty) {
          return 'Még nincs értékelve'
        } else {
          return `${this.value}/${this.max} csillag`
        }
      }
    }
  }
</script>